export const UPDATE_MODAL_DATA = 'UPDATE_MODAL_DATA';
export const updateModalData = modalData => ({
  type: UPDATE_MODAL_DATA,
  modalData: modalData
})
